module.exports = __webpack_public_path__ + "img/p-8.cdb6df3c.png";